import Swiper, { Navigation, Pagination } from "swiper";

export default class ProgramSlider {
  constructor(selector = ".c-program-slider__slider") {
    document.querySelectorAll(selector).forEach((el) => this.init(el));
  }

  init(el) {
    const root = el.closest(".c-program-slider");
    const nextEl = root?.querySelector(".c-program-slider__btn.-next");
    const prevEl = root?.querySelector(".c-program-slider__btn.-prev");
    const paginationEl = root?.querySelector(".c-program-slider__pagination");

    new Swiper(el, {
      modules: [Navigation, Pagination],
      slidesPerView: "auto",
      loop: true,
      spaceBetween: 16,
      centeredSlides: true,
      grabCursor: true,
      navigation: {
        nextEl,
        prevEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 16,
        },
      },
    });
  }
}
